export enum ScreeningTabEnum {
    Introduction = "introduction",
    StartScreening = "start-screening",
    Feedback = "feedback"
}
